module.exports = __webpack_public_path__ + "static/media/round-shadow.09ba06b7.svg";